import React, {Component} from "react";
import {Button, Col, Modal, Row, Table} from "react-bootstrap";

export default class InvalidReceiptList extends Component {

    state = {
        receipts: [],
        currentPage: 1,
        pageSize: 50,
        searchDDTD: '',
        searchSeller: '',
        dateFrom: '',
        dateTo: '',
        selectedIds: new Set(),
        batchModal: null,
        isBatchRunning: false,
        sendingIds: new Set(), // ids currently sending (single send)
        sendStatus: {} // id -> 'success' | 'error' (temporary)
    }

    refreshExchanges = () => {
        const applyList = (list) => this.setState({receipts: Array.isArray(list) ? list : []});

        fetch('/rest/receipt/invalid/list')
            .then(res => res.ok ? res.json() : Promise.reject())
            .then((result) => {
                applyList(Array.isArray(result) ? result : []);
            })
            .catch(() => applyList([]));
    }

    componentDidMount() {
        this.refreshExchanges();
    }

    // Single send without modal: disable button, show inline progress, brief success/error state
    sendOne = async (receipt) => {
        if (!receipt || !receipt.id) return;
        const id = receipt.id;
        // Update sending state
        this.setState(prev => {
            const next = new Set(prev.sendingIds || []);
            next.add(id);
            const status = {...(prev.sendStatus || {})};
            delete status[id];
            return {sendingIds: next, sendStatus: status};
        });

        try {
            const resp = await fetch('/rest/receipt/invalid/send/' + encodeURIComponent(id));
            if (!resp.ok) throw new Error(resp.statusText || 'Error');
            // Refresh list on success
            await this.refreshExchanges();
            // Mark success briefly
            this.setState(prev => ({
                sendStatus: {...prev.sendStatus, [id]: 'success'}
            }));
        } catch (e) {
            // Mark error briefly; keep console log for debugging
            // eslint-disable-next-line no-console
            console.error('Send invalid receipt failed', id, e);
            this.setState(prev => ({
                sendStatus: {...prev.sendStatus, [id]: 'error'}
            }));
        } finally {
            // Remove from sendingIds and clear status after timeout
            this.setState(prev => {
                const next = new Set(prev.sendingIds || []);
                next.delete(id);
                return {sendingIds: next};
            });
            setTimeout(() => {
                this.setState(prev => {
                    const status = {...(prev.sendStatus || {})};
                    if (status[id]) delete status[id];
                    return {sendStatus: status};
                });
            }, 2000);
        }
    }

    toggleSelectOne = (id, checked) => {
        this.setState(prev => {
            const next = new Set(prev.selectedIds || []);
            if (checked) next.add(id); else next.delete(id);
            return {selectedIds: next};
        });
    }

    toggleSelectAllCurrentPage = (pageItems, checked) => {
        this.setState(prev => {
            const next = new Set(prev.selectedIds || []);
            const ids = pageItems.map(r => r.id);
            if (checked) {
                ids.forEach(id => next.add(id));
            } else {
                ids.forEach(id => next.delete(id));
            }
            return {selectedIds: next};
        });
    }

    runBatchSend = async (ids) => {
        if (!ids || ids.length === 0) return;
        if (this.state.isBatchRunning) return;

        this.setState({
            isBatchRunning: true,
            batchModal: (
                <Modal size={'lg'} show={true} centered>
                    <Modal.Header className={'fw-bold'}>Илгээх</Modal.Header>
                    <Modal.Body>
                        <div>Нийт: {ids.length}. Илгээж байна, түр хүлээнэ үү...</div>
                    </Modal.Body>
                </Modal>
            )
        });

        let ok = 0, fail = 0;
        const failed = [];
        for (let i = 0; i < ids.length; i++) {
            const id = ids[i];
            // Update progress text
            this.setState({
                batchModal: (
                    <Modal size={'lg'} show={true} centered>
                        <Modal.Header className={'fw-bold'}>Илгээх</Modal.Header>
                        <Modal.Body>
                            <div className={'mb-2'}>
                                Нийт: {ids.length} | Амжилттай: {ok} | Амжилтгүй: {fail}
                            </div>
                            <div>Илгээж буй ДДТД: {id} ({i + 1}/{ids.length})</div>
                        </Modal.Body>
                    </Modal>
                )
            });

            try {
                const resp = await fetch('/rest/receipt/invalid/send/' + encodeURIComponent(id));
                if (!resp.ok) throw new Error(resp.statusText || 'Error');
                ok++;
            } catch (e) {
                fail++;
                failed.push(id);
            }
        }

        // Refresh data and update selection: remove successful ids
        await this.refreshExchanges();
        this.setState(prev => {
            const next = new Set(prev.selectedIds || []);
            ids.forEach(id => next.delete(id));
            failed.forEach(id => next.add(id)); // keep failures selected
            return {selectedIds: next};
        });

        // Show final summary
        this.setState({
            isBatchRunning: false,
            batchModal: (
                <Modal size={'lg'} show={true} centered>
                    <Modal.Header className={'fw-bold'}>Илгээх</Modal.Header>
                    <Modal.Body>
                        <div className={'mb-2'}>
                            Нийт: {ids.length} | Амжилттай: {ok} | Амжилтгүй: {fail}
                        </div>
                        {fail > 0 && (
                            <div>
                                Амжилтгүй: {failed.join(', ')}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-primary border"
                                style={{backgroundColor: '#2C6A8C', borderRadius: '10px',margin: 2}} onClick={() => this.setState({batchModal: null})}>Хаах</Button>
                    </Modal.Footer>
                </Modal>
            )
        });
    }

    render() {

        // derive filtered and paginated list similar to Merchant list
        const ddtq = (this.state.searchDDTD || '').trim().toLowerCase();
        const selq = (this.state.searchSeller || '').trim().toLowerCase();
        const {dateFrom, dateTo} = this.state;
        const matches = (v, q) => (v ?? '').toString().toLowerCase().includes(q);
        const parseCreated = (s) => {
            if (!s || typeof s !== 'string') return null;
            // Convert "YYYY-MM-DD HH:mm:ss" to a parsable format
            const isoLike = s.replace(' ', 'T');
            const d = new Date(isoLike);
            return isNaN(d.getTime()) ? null : d;
        };
        const startDate = dateFrom ? new Date(dateFrom + 'T00:00:00.000') : null;
        const endDate = dateTo ? new Date(dateTo + 'T23:59:59.999') : null;
        const withinRange = (createdStr) => {
            if (!startDate && !endDate) return true;
            const d = parseCreated(createdStr);
            if (!d) return false;
            if (startDate && d < startDate) return false;
            if (endDate && d > endDate) return false;
            return true;
        };
        const filtered = (Array.isArray(this.state.receipts) ? this.state.receipts : []).filter(r => {
            const okDDT = ddtq ? matches(r?.id, ddtq) : true;
            const sellerStr = (r?.merchantTIN ?? '') + ' ' + (r?.merchantName ?? '');
            const okSeller = selq ? matches(sellerStr, selq) : true;
            const okDate = withinRange(r?.createdDate);
            return okDDT && okSeller && okDate;
        });
        const total = filtered.length;
        const totalPages = Math.max(1, Math.ceil(total / this.state.pageSize));
        const page = Math.min(this.state.currentPage, totalPages);
        const start = (page - 1) * this.state.pageSize;
        const pageItems = filtered.slice(start, start + this.state.pageSize);

        const selectedIds = this.state.selectedIds || new Set();
        const selectedCountOnPage = pageItems.filter(r => selectedIds.has(r.id)).length;
        const allOnPageSelected = pageItems.length > 0 && selectedCountOnPage === pageItems.length;
        const someOnPageSelected = selectedCountOnPage > 0 && !allOnPageSelected;

        return (
            <div className={'container-xxl mt-3'}>
                {this.state.batchModal || ''}
                <Row className="align-items-center mb-1">
                    <Col lg={7} className={'d-flex gap-2 flex-wrap'}>
                        <div className="search-wrap" style={{flex: 1}}>
                            <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z"
                                      stroke="#8C99A5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="ДДТД оруулах"
                                value={this.state.searchDDTD}
                                onChange={(e) => this.setState({searchDDTD: e.target.value, currentPage: 1})}
                            />
                        </div>
                        <div className="search-wrap" style={{flex: 1}}>
                            <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z"
                                      stroke="#8C99A5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Борлуулагчийн регистр эсвэл нэр"
                                value={this.state.searchSeller}
                                onChange={(e) => this.setState({searchSeller: e.target.value, currentPage: 1})}
                            />
                        </div>
                        <div className="search-wrap" style={{flex: 1, minWidth: 180}}>
                            <input
                                type="date"
                                className="search-input"
                                placeholder="Эхлэх огноо"
                                value={this.state.dateFrom}
                                onChange={(e) => this.setState({dateFrom: e.target.value, currentPage: 1})}
                                title="Эхлэх огноо"
                            />
                        </div>
                        <div className="search-wrap" style={{flex: 1, minWidth: 180}}>
                            <input
                                type="date"
                                className="search-input"
                                placeholder="Дуусах огноо"
                                value={this.state.dateTo}
                                onChange={(e) => this.setState({dateTo: e.target.value, currentPage: 1})}
                                title="Дуусах огноо"
                            />
                        </div>
                    </Col>
                    <Col lg={5} className={'text-end'}>
                        <button className="btn btn-primary border"
                                style={{backgroundColor: '#2C6A8C', borderRadius: '10px', margin: 2}}
                                disabled={selectedIds.size === 0 || this.state.isBatchRunning}
                                onClick={() => this.runBatchSend(Array.from(selectedIds))}>{selectedIds.size} Илгээх
                        </button>
                        <button className="btn btn-primary border"
                                style={{backgroundColor: '#2C6A8C', borderRadius: '10px',margin: 2}}
                                onClick={() => this.setState({
                                    searchDDTD: '',
                                    searchSeller: '',
                                    dateFrom: '',
                                    dateTo: '',
                                    currentPage: 1
                                })}>Цэвэрлэх
                        </button>
                        <button className="btn btn-primary border"
                                style={{backgroundColor: '#2C6A8C', borderRadius: '10px', margin: 2}}
                                onClick={() => this.refreshExchanges()}>Шинэчлэх
                        </button>
                    </Col>
                </Row>

                <div className="p-2 mb-0 merchant-table-wrapper">
                    <div className="merchant-table-area">
                        <Table striped={false}
                               className={'table table-borderless align-middle merchant-table table-compact'}>
                            <thead>
                            <tr>
                                <th width={36}>
                                    {(() => {
                                        let refEl = null;
                                        return (
                                            <input
                                                ref={(el) => {
                                                    refEl = el;
                                                    if (el) el.indeterminate = someOnPageSelected;
                                                }}
                                                style={{
                                                    border: 0,
                                                    color: '#2C6A8C',
                                                    backgroundColor: '#2C6A8C',
                                                }}
                                                type="checkbox"
                                                className="form-check-input"
                                                aria-label="Бүх мөрийг сонгох (энэ хуудсанд)"
                                                checked={allOnPageSelected}
                                                onChange={(e) => this.toggleSelectAllCurrentPage(pageItems, e.target.checked)}
                                            />
                                        );
                                    })()}
                                </th>
                                <th width={200}>ДДТД</th>
                                <th width={150}>ТТД</th>
                                <th width={200}>Огноо</th>
                                <th>Алдаа</th>
                            </tr>
                            </thead>
                            <tbody>
                            {pageItems.length > 0 ? pageItems.map(receipt => (
                                <tr key={receipt.id}>
                                    <td className={'align-middle'}>
                                        <input
                                            type="checkbox"
                                            style={{
                                                border: 0,
                                                color: '#2C6A8C',
                                                backgroundColor: '#2C6A8C',
                                            }}
                                            className="form-check-input"
                                            aria-label={`Сонгох ДДТД ${receipt.id}`}
                                            checked={selectedIds.has(receipt.id)}
                                            onChange={(e) => this.toggleSelectOne(receipt.id, e.target.checked)}
                                        />
                                    </td>
                                    <td className={'align-middle'}>{receipt.id}</td>
                                    <td className={'align-middle'}>{receipt.merchantTIN}</td>
                                    <td className={'align-middle'}>{receipt.createdDate}</td>
                                    <td className={'align-middle'}>{receipt.errorMsg}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Мэдээлэл олдсонгүй</td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </div>

                    {total > 0 && (
                        <div className="pagination-bar">
                            <div className="text-muted small">Нийт: {total}</div>
                            <div className="d-flex align-items-center gap-2">
                                <button className="page-btn"
                                        onClick={() => this.setState({currentPage: Math.max(1, this.state.currentPage - 1)})}
                                        disabled={page === 1}>‹
                                </button>
                                {(() => {
                                    const items = [];
                                    for (let i = 1; i <= totalPages; i++) {
                                        items.push(
                                            <button key={`pg_${i}`}
                                                    className={`page-btn ${page === i ? 'active' : ''}`}
                                                    onClick={() => this.setState({currentPage: i})}>{i}</button>
                                        );
                                    }
                                    return items;
                                })()}
                                <button className="page-btn"
                                        onClick={() => this.setState({currentPage: Math.min(totalPages, this.state.currentPage + 1)})}
                                        disabled={page === totalPages}>›
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}